import { AccordionSettings } from './type';

export const accordionSettings: AccordionSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        regular: {
          color: 'black.main',
        },
      },
    },
  },
};
